module.exports = __webpack_public_path__ + "static/img/kb-phone-insurance.4f3029d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/kb-phone-insurance.jpg
// module id = NMib
// module chunks = 0